module.exports = __webpack_public_path__ + "static/media/naturepure.e420878d.png";